export default class {
  static getFilenameForDeviceThumb(deviceId) {
    let retVal = "wac_vital-signs.png";
    switch (deviceId) {
      case 1: // Carescape
        retVal = "ge_carescape.png";
        break;
      case 2: // Zoll X-Series
        retVal = "zoll-x-series.jpg";
        break;
      case 3: //
        retVal = "lifepak-15.png";
        break;
      case 4: //
        retVal = "corpuls_corpuls3.png";
        break;
      case 28: //
        retVal = "corpuls_corpuls3-4th-gen.png";
        break;
      case 5: //
        retVal = "wac_vital-signs.png";
        break;
      case 6: //
        retVal = "lifepak_AED1000.png";
        break;
      case 7: //
        retVal = "corpuls_corpuls1.png";
        break;
      case 8: //
        retVal = "medtronic_bis.png";
        break;
      case 9: //
        retVal = "corpuls_aed.png";
        break;
      case 10: //
        retVal = "propaq_md.png";
        break;
      case 11: //
        retVal = "nihon-kohden_TEC5600.png";
        break;
      case 12: //
        retVal = "nihon-kohden_TEC8300.png";
        break;
      case 13: //
        retVal = "philips_heartstart-MRx-black.png";
        break;
      case 14: //
        retVal = "philips_heartstart-MRx-white.png";
        break;
      case 15: //
        retVal = "philips_mx800.png";
        break;
      case 16: //
        retVal = "lifepak-20.png";
        break;
      case 17: //
        retVal = "zoll-r-series.png";
        break;
      case 18: //
        retVal = "medtronic_capnostream-35.png";
        break;
      case 19: //
        retVal = "ALSi6-Monitor.png";
        break;
      case 20: //
        retVal = "ALSi6-Defib.png";
        break;
      case 21: //
        retVal = "ALSi6-Numerics.png";
        break;
      case 22: //
        retVal = "ALSi6-Wave.png";
        break;
      case 23: //
        retVal = "ALSi6-AED.png";
        break;
      case 24: //
        retVal = "revel-ptv.png";
        break;
      case 25: //
        retVal = "schiller-defigard-touch-7.png";
        break;
      case 26: //
        retVal = "schiller-physiogard-touch-7.png";
        break;
      case 27: //
        retVal = "zoll-emv.png";
        break;
      case 31: //
        retVal = "tempus-ls.png";
        break;
      case 32: //
        retVal = "tempus-pro.png";
        break;
      case 34: //
        retVal = "generic-ventilator.png";
        break;
    }
    return retVal;
  }
  static getFilenameForPatientPhoto(patientPhotoId) {
    let retVal = "1m1.jpg";
    switch (patientPhotoId) {
      case 0:
        retVal = "1m1.jpg";
        break;
      case 1:
        retVal = "1m2.jpg";
        break;
      case 2:
        retVal = "4f1.jpg";
        break;
      case 3:
        retVal = "5f1.jpg";
        break;
      case 4:
        retVal = "5f2.jpg";
        break;
      case 5:
        retVal = "5m1.jpg";
        break;
      case 6:
        retVal = "6f1.jpg";
        break;
      case 7:
        retVal = "6f2.jpg";
        break;
      case 8:
        retVal = "7f1.jpg";
        break;
      case 9:
        retVal = "7m1.jpg";
        break;
      case 10:
        retVal = "7m2.jpg";
        break;
      case 11:
        retVal = "8f1.jpg";
        break;
      case 12:
        retVal = "8f2.jpg";
        break;
      case 13:
        retVal = "8m1.jpg";
        break;
      case 14:
        retVal = "9f1.jpg";
        break;
      case 15:
        retVal = "10f1.jpg";
        break;
      case 16:
        retVal = "10m1.jpg";
        break;
      case 17:
        retVal = "11m1.jpg";
        break;
      case 18:
        retVal = "12f1.jpg";
        break;
      case 19:
        retVal = "12m1.jpg";
        break;
      case 20:
        retVal = "18f1.jpg";
        break;
      case 21:
        retVal = "18f2.jpg";
        break;
      case 22:
        retVal = "18m1.jpg";
        break;
      case 23:
        retVal = "18m2.jpg";
        break;
      case 24:
        retVal = "18m3.jpg";
        break;
      case 25:
        retVal = "20f1.jpg";
        break;
      case 26:
        retVal = "20f2.jpg";
        break;
      case 27:
        retVal = "20f3.jpg";
        break;
      case 28:
        retVal = "20f4.jpg";
        break;
      case 29:
        retVal = "20f5.jpg";
        break;
      case 30:
        retVal = "20f6.jpg";
        break;
      case 31:
        retVal = "20f7.jpg";
        break;
      case 32:
        retVal = "20f8.jpg";
        break;
      case 33:
        retVal = "20f9.jpg";
        break;
      case 34:
        retVal = "20f10.jpg";
        break;
      case 35:
        retVal = "20f11.jpg";
        break;
      case 36:
        retVal = "20m1.jpg";
        break;
      case 37:
        retVal = "20m2.jpg";
        break;
      case 38:
        retVal = "20m3.jpg";
        break;
      case 39:
        retVal = "20m5.jpg";
        break;
      case 40:
        retVal = "20m5.jpg";
        break;
      case 41:
        retVal = "20m6.jpg";
        break;
      case 42:
        retVal = "20m7.jpg";
        break;
      case 43:
        retVal = "20m8.jpg";
        break;
      case 44:
        retVal = "20m9.jpg";
        break;
      case 45:
        retVal = "30f1.jpg";
        break;
      case 46:
        retVal = "30f2.jpg";
        break;
      case 47:
        retVal = "30f3.jpg";
        break;
      case 48:
        retVal = "30f4.jpg";
        break;
      case 49:
        retVal = "30f5.jpg";
        break;
      case 50:
        retVal = "30f6.jpg";
        break;
      case 51:
        retVal = "30f7.jpg";
        break;
      case 52:
        retVal = "30f8.jpg";
        break;
      case 53:
        retVal = "30f9.jpg";
        break;
      case 54:
        retVal = "30m1.jpg";
        break;
      case 55:
        retVal = "30m2.jpg";
        break;
      case 56:
        retVal = "30m3.jpg";
        break;
      case 57:
        retVal = "30m4.jpg";
        break;
      case 58:
        retVal = "30m5.jpg";
        break;
      case 59:
        retVal = "30m6.jpg";
        break;
      case 60:
        retVal = "30m10.jpg";
        break;
      case 61:
        retVal = "30m8.jpg";
        break;
      case 62:
        retVal = "30m9.jpg";
        break;
      case 63:
        retVal = "40f1.jpg";
        break;
      case 64:
        retVal = "40f2.jpg";
        break;
      case 65:
        retVal = "40f4.jpg";
        break;
      case 66:
        retVal = "40f5.jpg";
        break;
      case 67:
        retVal = "40m1.jpg";
        break;
      case 68:
        retVal = "40m2.jpg";
        break;
      case 69:
        retVal = "40m3.jpg";
        break;
      case 70:
        retVal = "50f1.jpg";
        break;
      case 71:
        retVal = "50f2.jpg";
        break;
      case 72:
        retVal = "50m1.jpg";
        break;
      case 74:
        retVal = "50m2.jpg";
        break;
      case 75:
        retVal = "50m3.jpg";
        break;
      case 76:
        retVal = "50m4.jpg";
        break;
      case 77:
        retVal = "60f1.jpg";
        break;
      case 78:
        retVal = "60f2.jpg";
        break;
      case 79:
        retVal = "60f3.jpg";
        break;
      case 80:
        retVal = "60f4.jpg";
        break;
      case 81:
        retVal = "60f5.jpg";
        break;
      case 82:
        retVal = "60f6.jpg";
        break;
      case 83:
        retVal = "60f7.jpg";
        break;
      case 84:
        retVal = "60f8.jpg";
        break;
      case 85:
        retVal = "60f9.jpg";
        break;
      case 86:
        retVal = "60f10.jpg";
        break;
      case 87:
        retVal = "60m1.jpg";
        break;
      case 88:
        retVal = "60m2.jpg";
        break;
      case 89:
        retVal = "60m3.jpg";
        break;
      case 90:
        retVal = "60m5.jpg";
        break;
      case 91:
        retVal = "60m6.jpg";
        break;
      case 92:
        retVal = "60m7.jpg";
        break;
      case 93:
        retVal = "60m8.jpg";
        break;
      case 94:
        retVal = "60m9.jpg";
        break;
      case 95:
        retVal = "60m10.jpg";
        break;
      case 96:
        retVal = "70f1.jpg";
        break;
      case 97:
        retVal = "70f2.jpg";
        break;
      case 98:
        retVal = "70f3.jpg";
        break;
      case 99:
        retVal = "70f4.jpg";
        break;
      case 100:
        retVal = "70m1.jpg";
        break;
      case 101:
        retVal = "70m2.jpg";
        break;
      case 102:
        retVal = "70m3.jpg";
        break;
      case 103:
        retVal = "70m4.jpg";
        break;
      case 104:
        retVal = "70m5.jpg";
        break;
      case 105:
        retVal = "80f1.jpg";
        break;
      case 106:
        retVal = "80m1.jpg";
        break;
    }
    return retVal;
  }
}
